import React, { FC, useContext } from 'react'
import { FormProvider } from 'react-hook-form'
import { useTranslation } from 'react-i18next'
import { FormGenerator, ModalWrapper } from '@microservices/wiskey-react-components'
import { Typography } from '@mui/material'

import { PageContext } from '@pages/DiagramsCreateOrEdit/DiagramsCreateOrEdit'

import { CommandParameters } from '@components/CommandParameters'
import { ModalFormContainer } from '@components/ModalFormContainer'
import { ScriptValueDialog } from '@components/ScriptValueDialog'
import { ColorSettings } from '@components/TextSettings/components/ColorSettings'

import { TYPES_SOURCE_OPTIONS } from '@constants'

import { useAddBarChartColumnDialog } from './hooks/useAddBarChartColumnDialog'

export const AddBarChartColumnDialog: FC = () => {
  const { t } = useTranslation()

  const { onCloseModal } = useContext(PageContext)

  const { inputs, state, handlers, methods } = useAddBarChartColumnDialog()

  const { currentNameScriptDialog, scriptHint, saveLoading } = state
  const { columnInputs, columnFieldInputs, columnAdditionalFieldInputs } = inputs
  const { onChangeColor, handleSaveColumn } = handlers
  const { watch, setValue } = methods

  const watchColor = watch('color')
  const watchFields = watch('fields')
  const watchObject = watch('object')
  const watchCommand = watch('command')
  const watchJsCreateValue = watch(currentNameScriptDialog)
  const watchJSForAll = watch('jsForAllFields')
  const watchIsCommandForEverySeries = watch('commandForEverySeries')

  // useEffect(() => {
  //   setInitialValue({
  //     pathArray: watchedPathArray,
  //     objectValue: watchedObjectValue,
  //   })
  // }, [watchedObjectValue])

  return (
    <ModalWrapper
      disabledSave={!state.isDirty || saveLoading}
      isShow={true}
      loading={saveLoading}
      title={`New/Edit Column`}
      width={1000}
      containerStyle={{
        px: 0.5,
        py: 0.5,
        // borderRadius: 0
      }}
      onSave={handleSaveColumn}
      onClose={() => {
        onCloseModal(state.isDirty)
      }}
    >
      {/*{isLoading && modalType === MODAL_TYPE.EDIT ? (*/}
      {/*  <Grid container alignItems={'center'} justifyContent={'center'} my={3}>*/}
      {/*    <CircularProgress />*/}
      {/*  </Grid>*/}
      {/*) : (*/}
      <ModalFormContainer maxHeight={600}>
        {/*<ConfirmModal*/}
        {/*  actionBtnText={t('parameters.resetModal.actionBtnText')}*/}
        {/*  containerStyle={{ px: 0.5, py: 0.5, 
            // borderRadius: 0 
        }}*/}
        {/*  isShow={isShowResetConfirmModal}*/}
        {/*  text={t('parameters.resetModal.text')}*/}
        {/*  title={t('parameters.resetModal.title')}*/}
        {/*  onClose={() => handleSetShowResetConfirmModal(false)}*/}
        {/*  onConfirm={handleResetParams}*/}
        {/*/>*/}
        <FormProvider {...methods}>
          <FormGenerator inputs={columnInputs} mainGridSpacing={0} />
          {watchCommand && (
            <>
              <CommandParameters
                disableFieldType
                commandCode={watchCommand.id}
                containerSx={{ mb: 1 }}
                label={t('contextMenuCreate.addMenuPointModal.parameters.label')}
                name='commandParameters'
                parametersMode='params'
                sourceCode={watchObject?.id as string}
                sourceTitle={watchObject?.label as string}
                typeSource={TYPES_SOURCE_OPTIONS.OBJECT}
              />
              <CommandParameters
                disableFieldType
                commandCode={watchCommand.id}
                containerSx={{ mb: 1 }}
                label={t('contextMenuCreate.addMenuPointModal.body.label')}
                name='commandBody'
                parametersMode='body'
                sourceCode={watchObject?.id as string}
                sourceTitle={watchObject?.label as string}
                typeSource={TYPES_SOURCE_OPTIONS.OBJECT}
              />
            </>
          )}

          {Boolean(watchCommand) && (
            <>
              <Typography variant='h6'>{t('addDialog.columnFields')}</Typography>
              <FormGenerator inputs={columnAdditionalFieldInputs} />
              {!(watchJSForAll || watchIsCommandForEverySeries) && (
                <FormGenerator inputs={columnFieldInputs} />
              )}
            </>
          )}
          <ColorSettings
            isEdit
            clearableColor={false}
            color={watchColor}
            label={'Color'}
            onChangeColor={onChangeColor}
          />
          {state.isOpenScriptValueDialog && (
            <ScriptValueDialog
              windowBoundaries
              hint={scriptHint}
              isShow={state.isOpenScriptValueDialog}
              modalType={'edit'}
              objectFields={[]}
              value={watchJsCreateValue}
              onClose={() => handlers.toggleOpenScriptValueDialog(false)}
              onSave={value => setValue(currentNameScriptDialog, value, { shouldDirty: true })}
            />
          )}
          {/*<Typography variant='h6'>{t('addDialog.parameters')}</Typography>*/}

          {/*<Grid container item justifyContent={'flex-end'} mt={0.5}>*/}
          {/*  <Button variant='outlined' onClick={handleClickReset}>*/}
          {/*    {t('parameters.resetButton')}*/}
          {/*  </Button>*/}
          {/*</Grid>*/}
        </FormProvider>
      </ModalFormContainer>
      {/*)}*/}
    </ModalWrapper>
  )
}
